import React from 'react';
import { Shield, CheckCircle, Lock } from 'lucide-react';

const Safety = () => {
  return (
    <section id="safety" className="section">
      <div className="container">
        <div className="safety-section">
          <div className="safety-content">
            <div className="safety-text">
              <div className="safety-badge">
                <Shield size={24} />
                <span>Safety First</span>
              </div>
              <h2>A Protected Sanctuary Online</h2>
              <p className="safety-description">
                We believe social media should build you up, not tear you down. 
                That's why Faith Connect uses advanced moderation to ensure a wholesome environment.
              </p>
              
              <ul className="safety-list">
                <li>
                  <CheckCircle className="check-icon" size={20} />
                  <span>24/7 AI & Human Moderation</span>
                </li>
                <li>
                  <CheckCircle className="check-icon" size={20} />
                  <span>Strict "Clean Content" Policy</span>
                </li>
                <li>
                  <CheckCircle className="check-icon" size={20} />
                  <span>Zero Tolerance for Harassment</span>
                </li>
                <li>
                  <CheckCircle className="check-icon" size={20} />
                  <span>Private & Secure Data Protection</span>
                </li>
              </ul>
            </div>
            <div className="safety-visual">
              <Lock size={120} strokeWidth={1} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Safety;
